import ora, { type Ora } from "ora";
import pc from "picocolors";

const frames = ["[    ]", "[=   ]", "[==  ]", "[=== ]", "[ ===]", "[  ==]", "[   =]"];

export function createOrgxSpinner(text: string): Ora {
  return ora({
    text: pc.cyan(text),
    spinner: {
      interval: 90,
      frames,
    },
  });
}

